module.exports = __webpack_public_path__ + "img/5_104.3553b856.png";